export default __webpack_public_path__ + "static/media/truck-blue.f53735ce.svg";